import React from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Text, Flex } from "@fluentui/react-northstar";

//  Reusable Donut Chart component using ApexCharts

const DonutChart = ({ title, value, total, color, label }) => {
  // Calculate remaining value
  const remaining = total - value;

  // Configure ApexChart options
  const options = {
    chart: {
      type: "donut",
      height: 250,
    },
    colors: [color, "#E5E7EB"],
    labels: ["Used", "Remaining"],
    plotOptions: {
      pie: {
        donut: {
          size: "70%",
          labels: {
            show: true,
            name: {
              show: false,
            },
            value: {
              show: false,
            },
            total: {
              show: false,
            },
          },
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      position: "bottom",
      horizontalAlign: "center",
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  };

  // Data series for the chart
  const series = [value, remaining];

  return (
    <Box
      style={{
        background: "#F9FAFB",
        borderRadius: "8px",
        padding: "1rem",
      }}
    >
      <Text
        size="large"
        weight="semibold"
        content={title}
        style={{ marginBottom: "1rem", color: "#374151" }}
      />

      <div style={{ position: "relative", height: "250px" }}>
        <ReactApexChart
          options={options}
          series={series}
          type="donut"
          height={250}
        />
      </div>

      <Flex column hAlign="center" style={{ marginTop: "1rem" }}>
        <Text
          size="largest"
          weight="bold"
          content={value.toLocaleString()}
          style={{ color: color }}
        />
        <Text
          size="small"
          content={label || "credits used"}
          style={{ color: "#6B7280" }}
        />
      </Flex>
    </Box>
  );
};

export default DonutChart;
